import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n  &&&&& {\n    .semi-row,\n    .row {\n      flex-direction: row;\n      flex-wrap: nowrap;\n    }\n    .gp-checkbox-container {\n      margin-right: ', ';\n    }\n\n    ', '\n  }\n'], ['\n  &&&&& {\n    .semi-row,\n    .row {\n      flex-direction: row;\n      flex-wrap: nowrap;\n    }\n    .gp-checkbox-container {\n      margin-right: ', ';\n    }\n\n    ', '\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n        .gp-row {\n          div {\n            text-align: center;\n            margin: auto;\n            font-size: 28px;\n          }\n        }\n      '], ['\n        .gp-row {\n          div {\n            text-align: center;\n            margin: auto;\n            font-size: 28px;\n          }\n        }\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: ', ';\n  font-size: ', ';\n  line-height: ', ';\n  flex-shrink: 0;\n  margin-right: 10px;\n  border-radius: 12px;\n  height: 36px;\n  padding: 10px 16px;\n'], ['\n  background-color: ', ';\n  color: ', ';\n  font-size: ', ';\n  line-height: ', ';\n  flex-shrink: 0;\n  margin-right: 10px;\n  border-radius: 12px;\n  height: 36px;\n  padding: 10px 16px;\n']);

import React, { PureComponent } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { TextAreaAutosize, Checkbox } from '../../..';
import injected from '../../../injected';
import Field from '../../components/Field';
import { styles, translations, utils } from 'gipsy-misc';

var Title = function (_PureComponent) {
  _inherits(Title, _PureComponent);

  function Title() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Title);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Title.__proto__ || Object.getPrototypeOf(Title)).call.apply(_ref, [this].concat(args))), _this), _this.getPlaceHolder = function (mode) {
      if (mode === 'reviewRequest') {
        return translations.reviewRequestPanel.titlePlaceholder;
      }
      return translations.taskPanel.titlePlaceholder;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Title, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.props.value && (injected.source === 'homebase' || injected.source === 'gipsybotme')) {
        /* doesnt work without timeout, set focus on title after task panel transition */
        this.timeout = setTimeout(function () {
          _this2.input.focus();
        }, 400);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          onChange = _props.onChange,
          mode = _props.mode,
          value = _props.value,
          completed = _props.completed,
          onSubmit = _props.onSubmit;

      return React.createElement(
        TitleField,
        { mode: mode, className: 'active' },
        React.createElement(
          'div',
          { className: 'gp-layout gp-row' + (mode === 'edit' ? ' row' : ' semi-row') },
          mode === 'edit' && React.createElement(Checkbox, { paramName: 'completed', checked: !!completed, onChange: onChange }),
          mode === 'reviewRequest' && React.createElement(
            ReviewLabel,
            null,
            utils.string.capitalize(translations.review.badges.review) + ':'
          ),
          mode === 'preview' ? React.createElement(
            'div',
            null,
            value
          ) : React.createElement(TextAreaAutosize, {
            placeholder: this.getPlaceHolder(mode),
            onSubmit: onSubmit,
            paramName: 'title',
            value: value,
            onChange: onChange,
            ref: function ref(_ref2) {
              _this3.input = _ref2;
            }
          })
        )
      );
    }
  }]);

  return Title;
}(PureComponent);

Title.propTypes = {
  mode: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  completed: PropTypes.number
};


var TitleField = styled(Field)(_templateObject, styles.spacings.small, function (_ref3) {
  var mode = _ref3.mode;
  return mode === 'preview' && css(_templateObject2);
});

var ReviewLabel = styled.div(_templateObject3, styles.colors.backgroundGreyColor, styles.colors.textPlaceholderColor, styles.fonts.fontSizeSmall, styles.fonts.fontSizeSmall);

export default Title;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TaskPanel/fields/Title/index.js
// module id = 503
// module chunks = 0